module.exports = __webpack_public_path__ + "static/media/icono3dGrisTick.9db23a08.svg";